import * as React from 'react'

export interface ICardProps {
  image: string
  label: string // Text to display
  name?: string // Should be the id for input
  variant?: string // Can be null or 'response'
  risk?: string
  subtitle?: string
}

// React.SFC indicates to TS that this component have access
// to a props named 'children'
const Card: React.SFC<ICardProps> = ({ label, name, variant, image, risk, subtitle, children }) => {
  return (
    <div className={'Card' + (variant ? ` Card--${variant}` : '')}>
      {children && (
        <React.Fragment>
          {children}
          <label className="Card-content" htmlFor={name}>
            <div
              className="Card-img"
              style={{ backgroundImage: `url(${image})` }}
              aria-hidden="true"
            />
            <p className="Card-label">{label}</p>
          </label>
        </React.Fragment>
      )}

      {!children && (
        <div className="Card-content">
          <div
            className="Card-img"
            style={{ backgroundImage: `url(${image})` }}
            aria-hidden="true"
          />
          <div className="Card-label">
            <p className="Card-title">{label}</p>
            {(risk || subtitle) && (
              <div className="Card-extra">
                {risk && <p className="Card-risk">{risk}</p>}
                {subtitle && <p className="Card-subtitle">{subtitle}</p>}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default Card



// WEBPACK FOOTER //
// ./src/components/Card/Card.tsx